<template>
    <div v-show="modelValue" :id="modalID" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content" style="min-height: 467px !important">
                <div class="modal-body">
                    <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 20px">
                        <ul class="nav nav-segment d-flex w-100 sm-flex-column" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link d-flex" :class="{ active: currentTab === 'detail' }" @click="currentTab = 'detail'" style="gap: 5px; color: #677788"
                                    ><i class="bi-file-text" syle="color: #677788;"></i> <span>{{ $t('views.inventory.modals.productDetail.detail.title') }}</span></a
                                >
                            </li>
                            <li class="nav-item">
                                <a class="nav-link d-flex" :class="{ active: currentTab === 'offers' }" @click="currentTab = 'offers'" style="gap: 5px; color: #677788"
                                    ><i class="bi-box-seam" syle="color: #677788"></i> <span>{{ $t('views.inventory.modals.productDetail.offers.title') }}</span></a
                                >
                            </li>
                            <li class="nav-item">
                                <a class="nav-link d-flex" :class="{ active: currentTab === 'supply-and-notes' }" @click="currentTab = 'supply-and-notes'" style="gap: 5px; color: #677788"
                                    ><i class="bi-pencil" syle="color: #677788"></i> <span>{{ $t('views.inventory.modals.productDetail.supplyAndNotes.title') }}</span></a
                                >
                            </li>
                            <li class="nav-item">
                                <a class="nav-link d-flex" :class="{ active: currentTab === 'past-orders' }" @click="currentTab = 'past-orders'" style="gap: 5px; color: #677788"
                                    ><i class="bi-clock-history" syle="color: #677788"></i> <span>{{ $t('views.inventory.modals.productDetail.pastOrders.title') }}</span></a
                                >
                            </li>
                            <li class="nav-item">
                                <a class="nav-link d-flex" :class="{ active: currentTab === 'calculator' }" @click="currentTab = 'calculator'" style="gap: 5px; color: #677788"
                                    ><i class="bi-calculator" syle="color: #677788"></i> <span>{{ $t('views.inventory.modals.productDetail.calculator.title') }}</span></a
                                >
                            </li>
                            <li class="nav-item">
                                <a class="nav-link d-flex align-items-center" :class="{ active: currentTab === 'keepa' }" @click="showConfirmKeepaTab" style="gap: 5px; color: #677788"
                                    ><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.648438" width="14" height="14" rx="7" fill="#677788" />
                                        <path d="M12.6081 8.58732H9.24817V11.9473H6.19835V8.58732H2.83839V5.5375H6.19835V2.17754H9.24817V5.5375H12.6081V8.58732ZM6.35343 5.69258V8.43224H9.0414V5.69258H6.35343Z" fill="#001C2E" />
                                        <path d="M12.4831 8.46251H9.12312V11.8225H6.04746V8.46251H2.6875V5.4127H6.04746V2.05273H9.09728V5.4127H12.4572V8.46251H12.4831ZM6.22839 5.56777V8.30744H8.91636V5.56777H6.22839Z" fill="white" />
                                    </svg>
                                    <span>{{ $t('views.inventory.modals.productDetail.keepa.title') }}</span></a
                                >
                            </li>
                        </ul>
                        <button type="button" class="close-button btn btn-link" @click="closeModal"><i class="bi bi-x-lg" style="color: #677788"></i></button>
                    </div>

                    <div v-if="modelValue" class="tab-content">
                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'detail' }">
                            <Detail v-if="currentTab === 'detail'" />
                        </div>

                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'offers' }">
                            <Offers v-if="currentTab === 'offers'" />
                        </div>

                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'supply-and-notes' }">
                            <SupplyAndNotes v-if="currentTab === 'supply-and-notes'" />
                        </div>

                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'past-orders' }">
                            <PastOrders v-if="currentTab === 'past-orders'" />
                        </div>

                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'calculator' }">
                            <Calculator v-if="currentTab === 'calculator'" />
                        </div>

                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'keepa' }">
                            <Keepa v-if="currentTab === 'keepa'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Modal } from 'bootstrap'
import Detail from './Detail.vue'
import Offers from './Offers.vue'
import SupplyAndNotes from './SupplyAndNotes.vue'
import PastOrders from './PastOrders.vue'
import Calculator from './Calculator.vue'
import Keepa from './Keepa.vue'

export default {
    name: 'ProductDetail',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Detail,
        Offers,
        SupplyAndNotes,
        PastOrders,
        Calculator,
        Keepa,
    },
    data() {
        return {
            modalID: 'ProductDetail-' + crypto.randomUUID(),
            modalInstance: null,
            currentTab: 'detail',
        }
    },
    computed: {
        hasKeepaData() {
            return this.$store.state.inventory?.detail?.statuses?.has_keepa_data
        },
    },
    methods: {
        ...mapMutations('inventory', ['SET_CURRENT_CALCULATE']),
        closeModal() {
            this.modalInstance.hide()
            this.$emit('update:modelValue', false)
            this.currentTab = 'detail'
            this.SET_CURRENT_CALCULATE({})
        },
        showConfirmKeepaTab() {
            if (this.hasKeepaData) {
                this.currentTab = 'keepa'
            } else {
                if (confirm(this.$t('views.inventory.modals.productDetail.keepa.confirmTab'))) {
                    this.currentTab = 'keepa'
                }
            }
        },
    },
    watch: {
        modelValue: function (data) {
            if (data) {
                const modalEl = document.getElementById(this.modalID)
                this.modalInstance = new Modal(modalEl, { backdrop: true })
                this.modalInstance.show()
                modalEl.addEventListener('hidden.bs.modal', () => {
                    this.closeModal()
                })
            } else {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="scss">
.dp__theme_light {
    --dp-primary-color: #ffb53e;
}
.custom-form-control {
    max-height: 37px;
    font-size: 12px;
}
[id^='ProductDetail-'] {
    .modal-dialog {
        min-width: 1140px;
    }
    @media (width <= 1150px) {
        .modal-dialog {
            width: 100%;
            min-width: 100%;
        }
    }
    .modal-body {
        padding-top: 32px !important;
    }
    .close-button {
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:hover {
            background-color: #f8fafd;
        }
    }
    .modal-table {
        margin-bottom: 0 !important;
        border-radius: 5px;

        &.specs {
            td {
                width: 269px;
                height: 45px;

                &:nth-child(odd) {
                    border-right: 0 !important;
                }
            }
        }

        tbody {
            tr {
                td {
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 21px;
                    color: #677788;
                    height: 41px;
                }
                td:nth-child(odd) {
                    border-right: none;
                }
                td:nth-child(even) {
                    font-weight: 400;
                    color: #677788;
                    border-left: none;
                }
            }
        }

        .text-ellipsis {
            font-size: 11.9px;
            font-weight: 400;
            line-height: 17.9px;
            color: #677788;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            &.title {
                max-width: 250px;
            }

            &.category {
                max-width: 125px;
            }
        }
        .dp__input_wrap {
            width: auto;
            > input {
                padding-inline-end: 12px !important;
                font-size: 14px;
                border: 0.6px solid #e7eaf3;
                color: #677788;
                width: 125px !important;
            }
        }
    }

    .nav-segment {
        margin-right: 2rem;

        .nav-link {
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
        }
    }

    .multiselect {
        width: 140px !important;
        min-width: auto !important;

        &__placeholder {
            display: block !important;
            margin-bottom: 0 !important;
            padding-top: 0 !important;
        }

        &__tags {
            padding: 12px 40px 0 8px !important;
        }

        &__select {
            line-height: normal !important;
        }
    }
}
</style>
